import React, {useEffect, useState} from 'react'
import {Box, CircularProgress} from '@mui/material'
import {useAppSelector} from 'src/hooks'
import {STATUS} from 'src/constants/constants'
import apiClient from 'src/services/apiClient'
import {useBootstrapSession} from 'src/services/authentication/useBootstrapSession'
// eslint-disable-next-line no-restricted-imports
import MainRoutingPages from 'src/pages/mainRouting/MainRoutingPages'
import MainRoutingPagesNew from './MainRoutingPagesNew'
import ThemeProviderNew from 'src/theme-new/ThemeProviderNew'
import ConsentsAcceptancePageNew from 'src/pages-new/consentsAcceptance/ConsentsAcceptancePageNew'
import {needsConsentAcceptance} from 'src/pages-new/consentsAcceptance/utils'
import {syncPushToken} from 'src/services/push/webPush'

export default function MainRoutingPagesGate(): JSX.Element {
  const statusConfig = useAppSelector(({pspConfigReducer}) => pspConfigReducer.status)
  const statusUserInfo = useAppSelector(({userReducer}) => userReducer.status)
  const newStyleEnabled = useAppSelector(state => state.pspConfigReducer.data.newStyleEnabled)
  const userInfo = useAppSelector(state => state.userReducer.data)
  const consentCheckboxOptions = useAppSelector(state => state.pspConfigReducer.data.firstLoginConfiguration?.consentCheckboxOptions)

  // Lock the new/legacy decision once both configs are fulfilled.
  // Without this, when newStyleEnabled=false the legacy MainRoutingPages mounts and calls
  // apiClient.pspConfig() again, resetting status to PENDING, which would cause the gate
  // to unmount MainRoutingPages and re-show the spinner indefinitely.
  const [ready, setReady] = useState(false)

  const {sessionReady} = useBootstrapSession()

  useEffect(() => {
    if (!sessionReady) return
    apiClient.getProfile()
    apiClient.pspConfig()
  }, [sessionReady])

  useEffect(() => {
    if (
      !ready &&
      statusConfig === STATUS.FULFILLED &&
      statusUserInfo === STATUS.FULFILLED
    ) {
      setReady(true)
    }
  }, [statusConfig, statusUserInfo, ready])

  // Web push: keeps this device in users.webDeviceTokens current (token rotated by Firebase,
  // lastSeenAt once a day). Covers both UI stacks, hence here rather than in a page.
  useEffect(() => {
    if (ready) {
      syncPushToken(userInfo.webDeviceTokens).catch(() => {})
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready])

  if (!ready) {
    return (
      <ThemeProviderNew>
        <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh'}}>
          <CircularProgress />
        </Box>
      </ThemeProviderNew>
    )
  }

  if (newStyleEnabled) {
    if (needsConsentAcceptance(userInfo, consentCheckboxOptions)) {
      return (
        <ThemeProviderNew>
          <ConsentsAcceptancePageNew />
        </ThemeProviderNew>
      )
    }
    return (
      <ThemeProviderNew>
        <MainRoutingPagesNew />
      </ThemeProviderNew>
    )
  }

  return <MainRoutingPages />
}
